__turbopack_context__.v({
  "borderedInputWrapper": "Autocomplete-module__FIGxFG__borderedInputWrapper",
});
